import OceanManualQuote from "../components/ManualQuoteOcean";

const OceanManualQuoteManagement = () => {
  return <OceanManualQuote />;
};
export default OceanManualQuoteManagement;
